module.exports = __webpack_public_path__ + "img/758.706754dc.png";